module.exports = __webpack_public_path__ + "img/neumobot.96c8f867.png";